export default __webpack_public_path__ + "static/media/addPlus.c7bd23a5.svg";